<template>
  <v-list-item density="compact">
    <v-list-item-title class="dropdown-item">
      <div class="icon-wrapper">
        <slot name="icon">
          <app-material-icon 
            v-if="icon"
            :name="icon"
            color="#4F565D"
          />
          <v-img v-else-if="img" :src="img" />
        </slot>
      </div>
      <slot name="default">{{ label }}</slot>
      <AppFeatureTag
        v-if="tag"
        :tag="tag"
        size="sm"
        class="ml-auto"
      />
    </v-list-item-title>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppFeatureTag, { FeatureTag } from '@/common/AppFeatureTag.vue';

export default defineComponent({
  name: 'AppDropdownButtonItem',
  components: {
    AppFeatureTag,
  },
  props: {
    icon: {
      type: String,
      required: false,
    },
    img: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    tag: {
      type: String as PropType<FeatureTag>,
      required: false,
    },
  },
})
</script>

<style scoped lang="scss">
.dropdown-item {
  display: flex;
  align-items: center;
  column-gap: 8px;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
  }
}
</style>
